import { ChevronLeft, Gift } from "lucide-react";

export function HomeReferralGiftBanner({
  onClick,
  onArrowClick,
  title = "10 ريال هدية لك",
  subtitle = "تمم أول طلب واحصل على كاش باك إضافي",
}: {
  onClick: () => void;
  onArrowClick: () => void;
  title?: string;
  subtitle?: string;
}) {
  return (
    <div className="px-4 mt-3">
      <button
        type="button"
        onClick={onClick}
        className="w-full rounded-2xl overflow-hidden shadow-md bg-gradient-to-l from-primary to-primary/80 text-primary-foreground"
      >
        <div className="flex items-center gap-3 px-3 py-3.5 text-start" dir="rtl">
          <div className="shrink-0 w-10 h-10 rounded-xl bg-black/10 flex items-center justify-center">
            <Gift className="w-5 h-5" />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-sm font-extrabold leading-tight">
              {title}
            </p>
            <p className="text-xs opacity-90 mt-0.5">
              {subtitle}
            </p>
          </div>

          <button
            type="button"
            aria-label="الانتقال لصفحة الإحالة"
            onClick={(e) => {
              e.stopPropagation();
              onArrowClick();
            }}
            className="shrink-0 p-1.5 rounded-full bg-black/10 hover:bg-black/20 transition-colors"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>
        </div>
      </button>
    </div>
  );
}

